import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'
import { toDocumentFormatWithTime } from 'helpers/dateHelper'
import _ from 'lodash'
import AppTable from './AppTable/AppTable'
import { toCurrencyFormat } from 'helpers/utils'
import { i18n } from 'data/i18n'
import { PAYMENT_STATUS } from 'data/paymentConts'
import { BookingStatusEnum } from 'data/bookingStatus'
import { OPERATION_TYPE } from 'enums/payments'
import bookingsService from 'services/admin/bookingsService'
import { ORDER_STATUS } from 'data/i18n'

export const SubOrderPayments = ({ subOrder, onClose, options }) => {
    const columnConfig = [
        {
            key: 'createdAt',
            label: 'Дата оплаты',
            formatter: (v) => toDocumentFormatWithTime(v)
        },
        {
            key: 'amount',
            label: 'Сумма оплаты',
            render: (i) => toCurrencyFormat(i.amount, i.currency)
        },
        {
            key: 'operationType',
            label: 'Тип операций',
            render: (i) => i.operationType ? i18n[i.operationType] : ""
        },
        {
            key: 'amountInUSD',
            label: 'Сумма оплаты в долларах',
            render: (i) => toCurrencyFormat(i.amountInUSD, "USD")
        },
        {
            key: 'exchangeRate',
            label: 'По курсу',
            render: (i) => i.exchangeRate
        },
        {
            key: 'paymentMethod',
            label: 'Способ оплаты',
            formatter: (v) => v === 'cash' ? 'Наличные' : v
        },
        {
            key: 'status',
            label: 'Статус',
            formatter: (v) => PAYMENT_STATUS[v]
        },
        {
            key: 'comment',
            label: 'Комментарий',
        },
    ]
    const hideButtons = _.get(options, 'hideButtons')


    const totalPayed = () => {
        if (!subOrder.paymentHistories) {
            return 0
        }
        const total = subOrder.paymentHistories.filter(p => p.operationType === OPERATION_TYPE.PAYMENT).reduce((acc, cur) => {
            return Number(acc) + Number(cur.amount)
        }, 0)

        return Number(total).toFixed(2)
    }

    const totalRefund = () => {
        if (!subOrder.paymentHistories) {
            return 0
        }
        const total = subOrder.paymentHistories.filter(p => p.operationType === OPERATION_TYPE.REFUND).reduce((acc, cur) => {
            return Number(acc) + Number(cur.amount)
        }, 0)

        return Number(total).toFixed(2)
    }

    const remaining = () => {
        const diff = (totalPayed() - Number(totalRefund() || 0))
        const result = Number(subOrder.totalAmount - diff)
        if (result === 0) {
            return `0 KZT`
        }
        if (result < 0) {
            return `0 KZT (+${Math.abs(result)} KZT)`
        }
        return toCurrencyFormat(result, subOrder.currency)
    }

    const hideOrShowPaymentDetails = async () => {
        try {
            await bookingsService.hideOrShowPaymentDetails(subOrder.id, {
                isPaymentDetailsHidden: !subOrder.isPaymentDetailsHidden
            })
            alert('Операция выполнена успешно!')
        } catch (error) {
            console.error('hideOrShowPaymentDetails error:', error)
        }

    }

    const paymentButtons = () => {
        if (subOrder.status === ORDER_STATUS.CANCELLED) {
            return null
        }

        const hidePaymentDetails = <Button onClick={() => hideOrShowPaymentDetails()}>Скрыть платежи для туриста</Button>

        if (subOrder.status === BookingStatusEnum.CREATED) {
            return <>
                <Button onClick={() => onClose(OPERATION_TYPE.PAYMENT)}>Добавить платеж</Button>
                {hidePaymentDetails}
            </>
        }
        if (subOrder.status === BookingStatusEnum.REFUND) {
            return <>
                <Button onClick={() => onClose(OPERATION_TYPE.REFUND)}>Возврат</Button>
                {hidePaymentDetails}
            </>
        }
        if ([BookingStatusEnum.PARTIAL_PAYMENT].includes(subOrder.status)) {
            return <>
                <Button onClick={() => onClose(OPERATION_TYPE.PAYMENT)}>Добавить платеж</Button>
                <Button onClick={() => onClose(OPERATION_TYPE.REFUND)}>Возврат</Button>
                {hidePaymentDetails}
            </>
        }

        if ([BookingStatusEnum.COMPLETED].includes(subOrder.status)) {
            return <>
                <Button onClick={() => onClose(OPERATION_TYPE.REFUND)}>Возврат</Button>
                {hidePaymentDetails}
            </>
        }
        return <>
            <Button onClick={() => onClose(OPERATION_TYPE.PAYMENT)}>Добавить платеж</Button>
            <Button onClick={() => onClose(OPERATION_TYPE.REFUND)}>Возврат</Button>
            {hidePaymentDetails}
        </>
    }

    const totals = () => {
        if (subOrder.status === ORDER_STATUS.REFUNDED) {
            return <div className='m-t-64 flex flex-col text-right'>
                <div>Общая стоимость тура: <span>{toCurrencyFormat(subOrder.totalAmount, subOrder.currency)}</span></div>
                <div>Оплачено: <span>{toCurrencyFormat(totalPayed(), subOrder.currency)}</span></div>
                <div>Сумма возврата: <span>{toCurrencyFormat(totalRefund(), subOrder.currency)}</span></div>
            </div>
        }
        return <div className='m-t-64 flex flex-col text-right'>
            <div>Общая стоимость тура: <span>{toCurrencyFormat(subOrder.totalAmount, subOrder.currency)}</span></div>
            <div>Оплачено: <span>{toCurrencyFormat(totalPayed() - Number(totalRefund() || 0), subOrder.currency)}</span></div>
            <div>Задолжность: <span>{remaining()}</span></div>
        </div>
    }

    return (
        <Card className='m-b-32'>
            <CardContent>
                <h3 className='m-b-32'>История платежей</h3>
                <AppTable data={subOrder.paymentHistories} columnConfig={columnConfig}></AppTable>
                {totals()}
            </CardContent>
            {hideButtons ? null : <CardActions>
                {paymentButtons()}
            </CardActions>}
        </Card>
    )
}
    